import React from 'react'

const ApprovedVideoIcon = ({color}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
        <g clipPath="url(#clip0_2_1111)">
          <path d="M11 0C4.91979 0 0 4.92031 0 11C0 17.0802 4.92031 22 11 22C17.0802 22 22 17.0797 22 11C22 4.91979 17.0797 0 11 0ZM11 20.5333C5.74333 20.5333 1.46665 16.2567 1.46665 11C1.46665 5.74329 5.74333 1.46665 11 1.46665C16.2567 1.46665 20.5333 5.74333 20.5333 11C20.5333 16.2567 16.2567 20.5333 11 20.5333Z" fill={ color? color : `#111AE9`}/>
          <path d="M16.8229 6.95789C16.5365 6.6715 16.0722 6.6715 15.7858 6.95789L9.25727 13.4864L6.21422 10.4434C5.92784 10.157 5.46348 10.157 5.17713 10.4434C4.89074 10.7298 4.89074 11.1941 5.17713 11.4805L8.73868 15.0421C9.02503 15.3284 9.48952 15.3283 9.77578 15.0421L16.8229 7.99494C17.1093 7.70855 17.1093 7.24427 16.8229 6.95789Z" fill={ color? color : `#111AE9`}/>
        </g>
        <defs>
          <clipPath id="clip0_2_1111">
            <rect width="22" height="22" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    )
}

export default ApprovedVideoIcon